import React from 'react'
import './FAQs.css';

const FAQs = () => {
  return (
    <div className="container-FAQ" style={{height:"908px"}}>
      <p>So far I didn't recieve any questions</p>
    </div>
  )
}

export default FAQs
